import { render, staticRenderFns } from "./HospitalDoctorInfo.vue?vue&type=template&id=b126527e&scoped=true&"
import script from "./HospitalDoctorInfo.vue?vue&type=script&lang=js&"
export * from "./HospitalDoctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./HospitalDoctorInfo.vue?vue&type=style&index=0&id=b126527e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b126527e",
  null
  
)

export default component.exports